import React, { PureComponent, Fragment } from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { executeGhostApi } from "../../../helpers/ghost";
import StyledLoading from "../../atoms/Loading/StyledLoading";
import GuidesTabCell from "../GuidesTabPages/GuidesTabCell";
import { GUIDES_CANONICAL_URL } from "../../../helpers/constants";
import { fonts } from "../../../styles/variables";

const RelatedPostsContainer = styled.div`
  margin-top: 50px;
`;

const TabCellOuter = styled.div``;

const StyledTitle = styled.h3`
  font-size: 30px !important;
  line-height: 0.9;
  font-family: ${fonts.fontInterstateUltraBlack};
  text-transform: uppercase;
  margin-bottom: 20px;
`;

class GuidesRelatedPosts extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      posts: [],
    };
  }

  async componentDidMount() {
    const { post } = this.props;

    // eslint-disable-next-line camelcase
    const { primary_tag } = post || {};
    // eslint-disable-next-line camelcase
    const primaryTag = primary_tag;

    const { slug } = primaryTag || {};
    const response = await executeGhostApi(slug);
    const relatedPosts = this.filterRelatedPosts(response, slug, post && post.slug);
    this.setState({ loading: false, posts: relatedPosts });
  }

  /**
   * Filters glossary posts, current article post and parent glossary post from the related posts.
   * Recently added posts to ghost do not have canonical url fields until manually added,
   * so this function also filters posts that only have canonical url fields.
   *
   * @param {Object} posts
   * @param {String} glossarySlug
   * @param {String} currentPostSlug\
   * @returns {Array}
   * */
  filterRelatedPosts = (posts, glossarySlug, currentPostSlug) =>
    posts
      .filter(
        (post) =>
          post &&
          post.primary_tag &&
          post.primary_tag.slug === glossarySlug &&
          post.tags &&
          post.tags.length < 2 &&
          post.slug !== currentPostSlug &&
          post.canonical_url
      )
      .slice(0, 2);

  /**
   * Gets the url patter to open the new related post.
   *
   * @param {Object} post
   * @returns {String}
   * */
  openPageDetails = (post) => {
    // eslint-disable-next-line camelcase
    const { canonical_url } = post;
    const urlPattern = canonical_url.replace(GUIDES_CANONICAL_URL, "");
    return urlPattern;
  };

  render() {
    const { location } = this.props;
    const { loading, posts } = this.state;
    if (loading) {
      return <StyledLoading />;
    }

    if (posts && posts.length < 1) {
      return null;
    }

    return (
      <RelatedPostsContainer>
        <StyledTitle tag={3} tightLineHeight uppercase mbMedium>
          RELATED
        </StyledTitle>
        {!loading &&
          posts &&
          posts.map((post) => (
            <Fragment key={`${post.id}`}>
              <TabCellOuter onClick={() => window.location.reload(false)}>
                <GuidesTabCell
                  title={post.title}
                  id={`${post.id}`}
                  image={post.feature_image || ""}
                  isGlossary={post.tags && post.tags.length > 1}
                  toUrlLink={this.openPageDetails(post)}
                  description={post.excerpt}
                  location={location}
                />
              </TabCellOuter>
            </Fragment>
          ))}
      </RelatedPostsContainer>
    );
  }
}

GuidesRelatedPosts.propTypes = {
  post: PropTypes.shape({}).isRequired,
  location: PropTypes.shape({}).isRequired,
};

export default GuidesRelatedPosts;
